import { FunctionComponent } from 'react';

import SectionArticles from 'components/content/sections/Articles';
import { ArticleType } from 'components/content/sections/Articles/types';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PageCoursesSectionHero: FunctionComponent<Props> = ({ translations, articles }) => {
    return (
        <StyledComponent className="page-blog-section-articles">
            <LayoutContainer size={Sizes.Large}>
                <SectionArticles
                    articleType={ArticleType.List}
                    articles={articles}
                    translations={translations?.articles}
                    excludeFirstArticle
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PageCoursesSectionHero;
